/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingAddress
 */
export interface BillingAddress {
    /**
     * Client city
     * @type {string}
     * @memberof BillingAddress
     */
    city?: string;
    /**
     * Client country using ISO 3166-1 alpha-3
     * @type {string}
     * @memberof BillingAddress
     */
    country?: string;
    /**
     * Client number and street
     * @type {string}
     * @memberof BillingAddress
     */
    addressAdditional1?: string;
    /**
     * Client number and street
     * @type {string}
     * @memberof BillingAddress
     */
    addressAdditional2?: string;
    /**
     * Client number and street
     * @type {string}
     * @memberof BillingAddress
     */
    addressAdditional3?: string;
    /**
     * Client Post Code/ZIP
     * @type {string}
     * @memberof BillingAddress
     */
    zipCode?: string;
    /**
     * Client State
     * @type {string}
     * @memberof BillingAddress
     */
    state?: string;
}

/**
 * Check if a given object implements the BillingAddress interface.
 */
export function instanceOfBillingAddress(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BillingAddressFromJSON(json: any): BillingAddress {
    return BillingAddressFromJSONTyped(json, false);
}

export function BillingAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'city': !exists(json, 'city') ? undefined : json['city'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'addressAdditional1': !exists(json, 'addressAdditional1') ? undefined : json['addressAdditional1'],
        'addressAdditional2': !exists(json, 'addressAdditional2') ? undefined : json['addressAdditional2'],
        'addressAdditional3': !exists(json, 'addressAdditional3') ? undefined : json['addressAdditional3'],
        'zipCode': !exists(json, 'zipCode') ? undefined : json['zipCode'],
        'state': !exists(json, 'state') ? undefined : json['state'],
    };
}

export function BillingAddressToJSON(value?: BillingAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'city': value.city,
        'country': value.country,
        'addressAdditional1': value.addressAdditional1,
        'addressAdditional2': value.addressAdditional2,
        'addressAdditional3': value.addressAdditional3,
        'zipCode': value.zipCode,
        'state': value.state,
    };
}

